import _ from 'lodash';
import Dropdown from 'components/base/Dropdown';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import useResourceTypes from '../../useResourceTypes';
import { StyledResourceTypeDropDown } from '../../ResourceAllocationOverview.style';
import { MAIN_UI_TYPES } from '../../resource_types';
const ResourceTypeDropDown = ({ resourceType, onChange }) => {
  const { resourceTypes } = useResourceTypes();
  const resourceTypesOnView = _.filter(resourceTypes, ({ displayIn }) =>
    displayIn?.includes(MAIN_UI_TYPES.ALLOCATION_OVER_TIME)
  );
  const resourceTypesOptions = _.map(resourceTypesOnView, resourceType => ({
    value: resourceType.key,
    displayValue: resourceType.name
  }));

  const onDropdownChange = resourceTypeKey => {
    onChange(resourceTypes[resourceTypeKey]);
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.RESOURCE_ALLOCATION,
      click_type:
        TRACKING.CLICK.RESOURCE_ALLOCATION.ALLOCATION_OVER_TIME_CHART.DROPDOWN,
      value: resourceTypeKey
    });
  };

  return (
    <StyledResourceTypeDropDown>
      <Dropdown
        dataCy='resource-type-dropdown'
        multiple={false}
        options={resourceTypesOptions}
        onChange={onDropdownChange}
        selectedValue={resourceType.key}
      />
    </StyledResourceTypeDropDown>
  );
};

export default ResourceTypeDropDown;
